import React from "react";
import { Button } from "antd";
import { LoginOutlined, PictureOutlined } from "@ant-design/icons";
import { getCategoryColor } from "../../theme/categoryColors";
import styles from "./SceneCard.module.scss";

/**
 * SceneCard — fila de escena VR reaprovechable (design system).
 *
 * Muestra todos los datos de una escena sin apretarlos: miniatura, titulo,
 * autor ("Creado por X") y tags de categoria con punto de color, mas una
 * accion "Entrar". Pensada para listados (Itinerarios, etc.).
 *
 * Props:
 *  - scene: { title, bannertopUrl|banner, category[], subcategory[] }
 *  - createdBy?: string (default "Educa360")
 *  - enterLabel?: string
 *  - onEnter?: (scene) => void
 *  - selected?: boolean
 */
const CAT_COLORS = {
  biologia: "#16a934",
  biology: "#16a934",
  geografia: "#f9b016",
  geography: "#f9b016",
  historia: "#c26b2e",
  history: "#c26b2e",
  matematicas: "#2d7ff9",
  math: "#2d7ff9",
  maths: "#2d7ff9",
  arte: "#b5179e",
  art: "#b5179e",
  "vida saludable": "#00a75a",
  "ciencias naturales": "#16a934",
  "ciencias humanas": "#7b61ff",
};

function normalize(cat) {
  return String(cat || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");
}

// Punto de categoria = FUENTE UNICA (ui/theme/categoryColors), igual que el
// catalogo de Salas. CAT_COLORS queda solo como fallback para subcategorias.
function catColor(cat) {
  return getCategoryColor(cat, CAT_COLORS[normalize(cat)] || "#8c9aa5");
}

export function SceneCard({
  scene = {},
  createdBy = "Educa360",
  enterLabel = "Entrar",
  onEnter,
  selected = false,
}) {
  const banner =
    scene.bannertopUrl || scene.bannerTopUrl || scene.banner || null;
  const cats = Array.isArray(scene.category)
    ? scene.category.filter(Boolean)
    : [];
  const subs = Array.isArray(scene.subcategory)
    ? scene.subcategory.filter(Boolean)
    : [];

  return (
    <div className={`${styles.card} ${selected ? styles.selected : ""}`}>
      <div className={styles.thumb}>
        {banner ? (
          <img src={banner} alt={scene.title || ""} loading="lazy" />
        ) : (
          <PictureOutlined className={styles.thumbIcon} />
        )}
      </div>

      <div className={styles.body}>
        <div className={styles.title} title={scene.title}>
          {scene.title || "—"}
        </div>
        <div className={styles.author}>Creado por {createdBy}</div>
        {cats.length || subs.length ? (
          <div className={styles.tags}>
            {cats.map((c) => (
              <span className={styles.tag} key={c}>
                <span
                  className={styles.dot}
                  style={{ background: catColor(c) }}
                />
                {c}
              </span>
            ))}
            {subs.length ? (
              <span className={styles.sub}>{subs.join(", ")}</span>
            ) : null}
          </div>
        ) : null}
      </div>

      <div className={styles.action}>
        <Button
          type="primary"
          icon={<LoginOutlined />}
          onClick={() => onEnter?.(scene)}
        >
          {enterLabel}
        </Button>
      </div>
    </div>
  );
}

export default SceneCard;
